import React from "react";
import "./PrivacyPolicy.css";

export default function PrivacyPolicy({
  siteName = "Institute of Corrosion Control in India",
  siteUrl = "EAC International LLC",
  contactEmail = "heramb@eac-international.com",
  lastUpdated = "August 20, 2025",
}) {
//   const handlePrint = () => window.print();

  return (
    <main className="privacy-container">
      <header className="privacy-header">
        <div>
          <h1>Privacy Policy for {siteName}</h1>
          <p>Last updated: {lastUpdated}</p>
          <p>
            Website: <a href={siteUrl}>{siteUrl}</a>
          </p>
          <p>
            Contact: <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
          </p>
        </div>
        {/* <button onClick={handlePrint} className="print-btn">
          Print / Save PDF
        </button> */}
      </header>

      <section className="privacy-content">
        <p>
          At <strong>{siteName}</strong> (accessible from{" "}
          <a href={siteUrl}>{siteUrl}</a>), your privacy is one of our top
          priorities. This Privacy Policy explains what information we collect,
          how we use it, and your rights regarding your personal data.
        </p>

        <h2>1. Information We Collect</h2>
        <ul>
          <li>
            <strong>Personal Information</strong>: name, email, phone, etc.
          </li>
          <li>
            <strong>Usage Data</strong>: IP, browser type, pages visited, time
            spent.
          </li>
          <li>
            <strong>Cookies</strong>: used for analytics and user experience.
          </li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>Provide and maintain our website.</li>
          <li>Improve and personalize services.</li>
          <li>Communicate updates and support.</li>
          <li>Analyze website usage.</li>
          <li>Prevent fraud and misuse.</li>
        </ul>

        <h2>3. Cookies & Tracking</h2>
        <p>
          Our site uses cookies. You may disable them in browser settings, but
          some features may not work properly.
        </p>

        <h2>4. Sharing Your Information</h2>
        <p>
          We do <strong>not</strong> sell your data. We may share it with
          trusted providers or legal authorities if required.
        </p>

        <h2>5. Data Security</h2>
        <p>
          We take precautions but cannot guarantee 100% security of online
          transmissions.
        </p>

        <h2>6. Your Rights</h2>
        <p>
          You may request access, correction, or deletion of your data. Contact
          us at <a href={`mailto:${contactEmail}`}>{contactEmail}</a>.
        </p>

        <h2>7. Third-Party Links</h2>
        <p>We are not responsible for external websites linked on our site.</p>

        <h2>8. Children’s Privacy</h2>
        <p>
          We do not knowingly collect data from children under 13. Contact us if
          you believe we have.
        </p>

        <h2>9. Changes</h2>
        <p>We may update this Privacy Policy from time to time.</p>

        <h2>10. Contact Us</h2>
        <p>
          Email: <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
        </p>
      </section>
    </main>
  );
}
